import { useEffect, useState, useRef } from "react";
import API from "../api";

const DEBOUNCE_MS = 300;

const useOtSignalSearch = (ip, q) => {
  const [signals, setSignals] = useState([]);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!ip) {
      setSignals([]);
      return;
    }

    clearTimeout(timerRef.current);
    const controller = new AbortController();

    timerRef.current = setTimeout(() => {
      setLoading(true);
      API.getOtSignals({ ip, ...(q ? { q } : {}) }, controller.signal)
        .then((res) => setSignals(res.data?.signals ?? []))
        .catch((err) => {
          if (err.name !== "CanceledError" && err.name !== "AbortError")
            console.error("[useOtSignalSearch] Failed to search OT signals:", err);
        })
        .finally(() => setLoading(false));
    }, DEBOUNCE_MS);

    return () => {
      clearTimeout(timerRef.current);
      controller.abort();
    };
  }, [ip, q]);

  return { signals, loading };
};

export default useOtSignalSearch;
